import { render, staticRenderFns } from "./language-select.vue?vue&type=template&id=eb3ae0b0&scoped=true&"
import script from "./language-select.vue?vue&type=script&lang=js&"
export * from "./language-select.vue?vue&type=script&lang=js&"
import style0 from "./language-select.vue?vue&type=style&index=0&id=eb3ae0b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb3ae0b0",
  null
  
)

export default component.exports